import React, { useCallback, useEffect, useMemo, useState } from "react"
import { useInterval } from "../../../hook/useInterval"
import { formatTime, getDuration } from "util/time"

/*
 * 300 seconds => 0D 0H 5M 0S and start ticking
 */
export function CountDown({ startTime, onTerminate }: { startTime: number; onTerminate?: Function }) {
    const [countdown, updateCountDown] = useState(startTime)

    const tick = useCallback(() => {
        if (startTime !== -1) {
            // -1 means un-initialized yet
            updateCountDown(prev => --prev)
        }
    }, [startTime])

    useEffect(() => {
        if (startTime !== 0 && countdown === 0) {
            if (onTerminate) {
                onTerminate()
            }
        }
    }, [startTime, countdown, onTerminate])

    useInterval(() => {
        tick()
    }, 1000)

    return useMemo(() => {
        return <>{formatTime(getDuration(countdown))}</>
    }, [countdown])
}
